import React from 'react';
import "./css/landing.css";

function Landing() {
  return (
    <section className="hero" id='landing'>
      <div className="hero-content">
        <h1>Moin, ich bin James</h1>
        <p>Hobby Softwareentwickler & IT-Schüler am BZTG</p>



        <a className="scroll-indicator" href="#about-me">
          <span></span>
        </a>
      </div>
    </section>
  );
}

export default Landing;
